// ../Modals/TestimonialUpdateModal.jsx
import React, { useState } from "react";
import axios from "axios";
import { path } from "../../path";

const TestimonialUpdateModal = ({ open, toggle, token }) => {
    const [video, setVideo] = useState(null);
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);

    if (!open) { return null };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!video) { return alert("Video file is required"); }
        if (!description.trim()) { return alert("Description is required"); }

        const formData = new FormData();
        formData.append("video", video);
        formData.append("description", description);

        try {
            setLoading(true);

            const res = await axios.post(`${path}/testimonials/upload`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                },
            });

            alert(res.data?.msg || "Testimonial uploaded successfully");
            setVideo(null);
            setDescription("");
            toggle();
        } catch (err) {
            console.log(err);
            alert(err.response?.data?.msg || "Upload failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-5">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold text-[#008080]">
                        Testimonial Update
                    </h2>

                    <button onClick={toggle} className="text-red-500 text-xl">
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block mb-1 font-medium">Video</label>
                        <input
                            type="file"
                            accept="video/*"
                            onChange={(e) => setVideo(e.target.files[0])}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>

                    <div className="mb-4">
                        <label className="block mb-1 font-medium">Description</label>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter testimonial description"
                            className="w-full border rounded px-3 py-2 min-h-[100px]"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-[#008080] text-white py-2 rounded font-medium"
                    >
                        {loading ? "Uploading..." : "Upload Testimonial"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default TestimonialUpdateModal;  